import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../services/Authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.authenticationService.isUserLoggedIn().pipe(
        map(data => {
          console.log('inside canActivate ' + data);
          if (data === false) {
            console.log('logging user out');
            this.authenticationService.logout();
            return true;
          } else {
            return !!data;
          }
        }
      ),
      catchError( () => {
        console.log('error');
        this.router.parseUrl('/');
        return of(false);
      }), );
  }
}
